import { render, staticRenderFns } from "./MensagensVetoPorEnteFederativoPorTipoLegislacao.vue?vue&type=template&id=015ce75e&scoped=true"
import script from "./MensagensVetoPorEnteFederativoPorTipoLegislacao.vue?vue&type=script&lang=js"
export * from "./MensagensVetoPorEnteFederativoPorTipoLegislacao.vue?vue&type=script&lang=js"
import style0 from "./MensagensVetoPorEnteFederativoPorTipoLegislacao.vue?vue&type=style&index=0&id=015ce75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ce75e",
  null
  
)

export default component.exports